import UnitSnippet    from 'scripts/defa/units/view-unit-snippet';
import CollectionView from 'scripts/poppet/collection-view';

/**
 * defa.views.UnitCollectionView
 * A CollectionView for UnitSnippets.
 * @version 1.2.0
 */

const UnitCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: UnitSnippet,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView requests to navigate.
	 * @param event The event string to navigate to.
	 */
	onChildviewNav: function( event ) {
		this.trigger( 'nav', event );
	},
	
	/**
	 * Triggers when a childView requests upgrade.
	 * @param childView The view that requested the upgrade.
	 */
	onChildviewUpgrade: function( childView ) {
		this.trigger( 'upgrade', childView );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UnitCollectionView;